import AdminDashboard from '../pages/admin/AdminDashboard';
import AdminTenants from '../pages/admin/AdminTenants';

export const adminRoutes = [
  { path: '/admin/dashboard', Component: <AdminDashboard /> },
  { path: '/admin/tenants',   Component: <AdminTenants /> },
];
